import React, { PropsWithChildren } from 'react';

import VideoLink from '@/components/video/VideoLink';

import { isYoutubeVideoUrl } from '@/constants/youtube-constants';

import AutoHyperlink from '@cineamo/ui/src/link/AutoHyperlink';

type VideoAwareAutoHyperlinkProps = PropsWithChildren<{
    trackingEvent?: string;
}>;

/**
 * AutoHyperlink that opens YouTube urls in the video player modal instead of navigating.
 */
const VideoAwareAutoHyperlink: React.FC<VideoAwareAutoHyperlinkProps> = ({ trackingEvent, children }) => {
    const componentDecorator = (decoratedHref: string, decoratedText: string, key: number) => {
        if (isYoutubeVideoUrl(decoratedHref)) {
            return (
                <VideoLink
                    key={key}
                    url={decoratedHref}
                    className="underline"
                    trackingEvent={trackingEvent}>
                    {decoratedText}
                </VideoLink>
            );
        }
        return (
            <a
                className="underline"
                href={decoratedHref}
                key={key}>
                {decoratedText}
            </a>
        );
    };

    return <AutoHyperlink componentDecorator={componentDecorator}>{children}</AutoHyperlink>;
};

export default VideoAwareAutoHyperlink;
